import DropdownActions from '../components/DropdownActions'
import DropdownMenuItem from './DropdownMenuItem'
import SetupParticipantsPageExpandedRow from './SetupParticipantsPageExpandedRow'
import SortableTableHeader from './SortableTableHeader'
import Table from './Table'
import TableColumn from './TableColumn'
import expandableTable from './ExpandableTable'
import selectableTable from './SelectableTable'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

const expandedRowRenderer = (participant, props) => (
  <SetupParticipantsPageExpandedRow
    assignments={props.assignmentsByParticipant[participant.id]}
  />
)

@selectableTable(mapData, handleSelect, { trackBy: 'id' })
@expandableTable(mapData, expandedRowRenderer, { trackBy: 'id' })
export default class ParticipantList extends PureComponent {
  static propTypes = {
    assignmentsByParticipant: PropTypes.object.isRequired,
    connectExpandableColumn: PropTypes.func.isRequired,
    connectSelectableColumn: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    onViewCommunications: PropTypes.func.isRequired,
    participants: PropTypes.arrayOf(PropTypes.object).isRequired
  }

  constructor(props) {
    super(props)

    this.renderActions = this.renderActions.bind(this)
    this.renderSortableColumn = this.renderSortableColumn.bind(this)

    this.state = {
      sortBy: 'firstLastInitial',
      order: 'asc'
    }
  }

  getStatus(participant) {
    return participant.deleteFl ? 'Deleted' : 'Enabled'
  }

  getProjectSegments(participant) {
    return participant.projectSegments
      .map(segment => segment.truncatedName)
      .join(', ')
  }

  renderActions(_, participant) {
    return (
      <DropdownActions>
        <DropdownMenuItem text="Edit" href={participant.profilePath} />
        <DropdownMenuItem
          text="Impersonate"
          href={participant.impersonatePath}
        />
        <DropdownMenuItem
          text="View Communication"
          href="#recruitNotes"
          data-toggle="modal"
          onClick={() => this.props.onViewCommunications(participant)}
        />
        {participant.deleteFl && (
          <DropdownMenuItem text="Restore" href={participant.restorePath} />
        )}
        {!participant.deleteFl && (
          <DropdownMenuItem
            text="Delete"
            href={participant.deletePath}
            data-method="delete"
            onClick={() =>
              confirm('Are you sure you want to delete this participant?')
            }
          />
        )}
      </DropdownActions>
    )
  }

  renderSortableColumn(label, dataKey) {
    const { sortBy, order } = this.state

    return (
      <SortableTableHeader
        active={dataKey === sortBy}
        label={label}
        onClick={order => this.setState({ order, sortBy: dataKey })}
        order={order}
      />
    )
  }

  compare(a, b) {
    const { sortBy } = this.state

    switch (sortBy) {
      case 'projectSegments':
        return this.getProjectSegments(a).localeCompare(
          this.getProjectSegments(b)
        )
      default:
        return a[sortBy].localeCompare(b[sortBy])
    }
  }

  sortedParticipants() {
    const { order } = this.state

    return this.props.participants.sort((a, b) => {
      return order === 'asc' ? this.compare(a, b) : this.compare(b, a)
    })
  }

  render() {
    const { connectExpandableColumn, connectSelectableColumn } = this.props

    return connectSelectableColumn(
      connectExpandableColumn(
        <Table data={this.sortedParticipants()}>
          <TableColumn
            dataGetter={this.getStatus}
            dataKey="status"
            label="Status"
          />
          <TableColumn
            dataKey="firstLastInitial"
            label="Name"
            headerRenderer={this.renderSortableColumn}
          />
          <TableColumn
            dataKey="responseCount"
            label="Responses"
            headerRenderer={this.renderSortableColumn}
          />
          <TableColumn
            dataGetter={this.getProjectSegments}
            dataKey="projectSegments"
            label="Segment"
            headerRenderer={this.renderSortableColumn}
          />
          <TableColumn
            dataKey="questionGroup"
            label="Assignment Group"
            headerRenderer={this.renderSortableColumn}
          />
          <TableColumn
            dataKey="lastResponseDt"
            label="Last Response"
            headerRenderer={this.renderSortableColumn}
          />
          <TableColumn
            align="right"
            cellRenderer={this.renderActions}
            dataKey="actions"
            label="Actions"
          />
        </Table>
      )
    )
  }
}

function mapData(props) {
  return props.participants
}

expandedRowRenderer.propTypes = {
  assignmentsByParticipant: PropTypes.object.isRequired
}

function handleSelect(participant, selected, props) {
  props.onSelect(participant, selected)
}



// WEBPACK FOOTER //
// ../src/components/ParticipantList.js